import { type ReactNode } from 'react';

import { Link } from '@spotify-internal/encore-web';

const MARKDOWN_LINK_REGEX = /\[([^\]]*)\]\(([^)]+)\)/g;

export const renderInlineMarkdownLinks = (text: string): ReactNode => {
  const parts: ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;

  for (const match of text.matchAll(MARKDOWN_LINK_REGEX)) {
    const matchIndex = match.index ?? 0;

    if (matchIndex > lastIndex) {
      parts.push(text.slice(lastIndex, matchIndex));
    }

    const [, linkText, href] = match;
    parts.push(
      <Link key={key++} href={href} target="_blank">
        {linkText}
      </Link>,
    );

    lastIndex = matchIndex + match[0].length;
  }

  if (parts.length === 0) {
    return text;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return <>{parts}</>;
};

export const stripMarkdownLinks = (text: string): string =>
  text.replace(MARKDOWN_LINK_REGEX, (_, linkText: string) => linkText);
